import React from "react";
import { Routes, Route } from "react-router-dom";
import Nav from "./components/Nav";
import Home from "./pages/Home";
import Tutorials from "./pages/Tutorials";
import ExplainAI from "./pages/ExplainAI";
import Productivity from "./pages/Productivity";
import BlogIndex from "./pages/blog/BlogIndex";
import BlogPost from "./pages/blog/BlogPost";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import Terms from "./pages/legal/Terms";
import AffiliateDisclosure from "./pages/legal/AffiliateDisclosure";
import NotFound from "./pages/NotFound";
import PageViewTracker from "./analytics/PageViewTracker";
import Footer from "./components/Footer";
import About from "./pages/legal/About"
import Contact from "./pages/legal/Contact"


function App() {
  return (
    <>
    <PageViewTracker />
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/tutorials" element={<Tutorials />} />
        <Route path="/explain-ai" element={<ExplainAI />} />
        <Route path="/productivity" element={<Productivity />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/affiliate-disclosure" element={<AffiliateDisclosure />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;